import { Link } from 'react-router-dom';

import Logo from './Logo';

/**
 * Minimal header: just a centered wordmark that links back home.
 * Navigation lives in the footer — the chrome here is decorative
 * brand presence, nothing to click around with.
 */
export default function Header() {
  return (
    <header className="sticky top-0 z-50 border-b border-line bg-bg/85 backdrop-blur-md backdrop-saturate-150">
      <div className="container-page flex h-16 items-center justify-center">
        <Link
          to="/"
          aria-label="Doodi"
          className="inline-flex items-center p-2 text-ink no-underline"
        >
          <Logo height={26} />
        </Link>
      </div>
    </header>
  );
}
